module.exports = __webpack_public_path__ + "img/1745.303ec45c.jpg";